import { message, Table, Tag } from "antd";
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { FC, useEffect, useState } from "react";
import { notification } from 'antd';
import moment from "moment-jalaali";
import Actions from "../actions";
import { useNavigate } from "react-router-dom";
import restful from "../../restful";

interface DataType {
    uid: "string",
    pid: "string",
    eid: "string",
    _id: "string",
    createdAt: "string",
    updatedAt: "string"
}

interface Params { page?: number; perPage?: number, sortDir: string, sort: string }

const AdiveryLogsTable: FC = () => {
    const navigate = useNavigate()
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [items, setItems] = useState<DataType[]>([]);
    const [pagination, setPagination] = useState<TablePaginationConfig>({
        current: 1,
        pageSize: 10,
    });

    const onDeleteAction = (id: string) => {
        restful.delete('/adivery-logs/' + id)
            .then((res) => {
                fetchData({ sortDir: "desc", sort: "createdAt", page: pagination.current, perPage: pagination.pageSize })
            })
            .catch((err) => message.error(err.message));
    }

    const columns: ColumnsType<DataType> = [
        { sorter: true, title: 'uid', dataIndex: 'uid', key: 'uid' },
        { sorter: true, title: 'pid', dataIndex: 'pid', key: 'pid' },
        { sorter: true, title: 'eid', dataIndex: 'eid', key: 'eid' },
        {
            defaultSortOrder: 'descend',
            sorter: true, title: 'زمان ایجاد', dataIndex: 'createdAt', key: 'createdAt', width: 170,
            render(val) {
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },
        {
            sorter: true, title: 'بروزرسانی', dataIndex: 'updatedAt', key: 'updatedAt', width: 170,
            render(val) {
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },

    ];

    const fetchData = (params: Params) => {
        setIsLoaded(true);
        restful.get(`/adivery-logs/paginate`, { params })
            .then((res) => {
                const result = res.data.result
                setItems(result.adiveryLogs);
                setPagination({
                    current: params.page,
                    pageSize: params.perPage,
                    total: result.adiveryLogsCount,
                })
            })
            .catch((error) => {
                return notification.error({
                    message: 'Error ' + error.statusCode,
                    description: error.message,
                });
            })
            .finally(() => { setIsLoaded(false) })
    };

    useEffect(() => {
        fetchData({ sortDir: "desc", sort: "createdAt", page: pagination.current, perPage: pagination.pageSize });
    }, [])

    const handleTableChange = (newPagination: TablePaginationConfig, filter: any, sorter: any) => {
        if (pagination.pageSize !== newPagination.pageSize) newPagination.current = 1
        fetchData({
            page: newPagination.current,
            perPage: newPagination.pageSize,
            sortDir: sorter.order === "ascend" ? "asc" : "desc",
            sort: sorter.field ?? "createdAt"
        });
    };

    return <Table
        columns={columns}
        dataSource={items}
        loading={isLoaded}
        rowKey="_id"
        pagination={pagination}
        onChange={handleTableChange}
    />
}

export default AdiveryLogsTable


